<template>
	<div class="resource-innovate">
		<div class="title">
			<span>创新创业课程资源</span>
			<el-input v-model="searchName" placeholder="检索关键字" style="float: right; width: 300px;"></el-input>
			<el-radio-group v-model="rtype" class="typeList">
				<el-radio-button label="全部">全部</el-radio-button>
				<el-radio-button label="img">图片</el-radio-button>
				<el-radio-button label="video">视频</el-radio-button>
				<el-radio-button label="pdf">文档</el-radio-button>
			</el-radio-group>
		</div>
		<el-divider></el-divider>
		<div class="resource-List">
			<div v-for="item in showData()" class="resource" @click="openDetails(item)">
				<img src='/file/sss.png' draggable="false"></img>
				<div :class="'name'+ ' r-'+item.fileType"> {{item.name}}</div>
				<div class="viewCount"><i class="el-icon-view"></i> 2626</div>
			</div>
		</div>
	</div>
</template>

<script>
	import resource from '@/assets/resource.js'
	export default {
		data() {
			return {
				rtype: '全部',
				searchName: "",
				resourceList: []
			}
		},
		created() {
			this.resourceList = resource
		},
		methods: {
			showData() {
				if (this.resourceList) {
					let _data = this.resourceList.filter(item => item.name.search(this.searchName) > -1)

					if (this.rtype != '全部') {
						_data = _data.filter(item => item.fileType == this.rtype)
					}
					return _data
				}
			},
			openDetails(val) {
				this.$emit('open_details', val)
			}
		}
	}
</script>

<style lang="scss">
	.resource-innovate {

		.title {
			line-height: 50px;
			font-weight: bold;
		}

		.typeList {
			float: right;
			margin-right: 60px;
			padding-top: 5px;


			.el-radio-button__inner {
				border: 0;
			}

			span {
				font-weight: bold;
			}

			span:hover {
				color: #7D3811 !important;
			}

			.is-active {
				.el-radio-button__inner {
					// background-color: #fff !important;
					// color: #7D3811 !important;
					background-color: #7D3811 !important;
					color: #fff !important;
					box-shadow: 0 0 0 0 #fff !important;
				}
			}
		}

		.el-divider {
			margin: 0;
			margin-bottom: 20px;
		}

		.resource-List {
			.resource {
				margin: 10px 16px 60px 16px;
				width: 320px;
				height: 180px;
				float: left;
				color: #000;
				cursor: pointer;

				img {
					border-radius: 8px;
					width: 100%;
					height: 100%;
				}

				.name {
					background-color: #F3EFEC;
					// background: -webkit-linear-gradient(top, #87878711, #35353566, #00000066);
					opacity: 0.99;
					font-size: 16px;
					text-align: left;
					height: 55px;
					line-height: 55px;
					margin-top: -10px;
					padding-left: 10px;
					border-bottom-right-radius: 8px;
					border-bottom-left-radius: 8px;
				}

				.r-img {
					background-image: url('/icon/img.png');
					background-repeat: no-repeat;
					background-position: 10px 10px;
					background-size: 32px 32px;
					padding-left: 50px;
				}

				.r-video {
					background-image: url('/icon/video.png');
					background-repeat: no-repeat;
					background-position: 10px 10px;
					background-size: 32px 32px;
					padding-left: 50px;
				}

				.r-pdf {
					background-image: url('/icon/pdf.png');
					background-repeat: no-repeat;
					background-position: 10px 10px;
					background-size: 32px 32px;
					padding-left: 50px;
				}


				.viewCount {
					opacity: 0.99;
					height: 55px;
					line-height: 55px;
					margin-top: -55px;
					margin-right: 10px;
					text-align: right;

					i {
						font-weight: bold;
					}
				}
			}


			.resource:hover {
				color: #fff;
				transform: scale(1.06);
				transition: 0.3s;

				.name {
					background-color: #7D3811;
				}
			}
		}
	}
</style>